module.exports = __webpack_public_path__ + "static/media/Listreport.7ac0a334.svg";